import { ErrorOutline } from '@mui/icons-material';
import { Typography, Container, Box } from '@mui/material';

const NotFound = () => {
  return (
    <Container maxWidth="sm">
      <Box sx={{ textAlign: 'center', mt: 8 }}>
        <ErrorOutline sx={{ fontSize: '6rem', color: 'error.main' }} />
        <Typography variant="h1" sx={{ mt: 2 }}>
          404 - Page Not Found
        </Typography>
        <Typography variant="body1" sx={{ mt: 2, fontSize: 20 }}>
          The page you are looking for does not exist.
        </Typography>
      </Box>
    </Container>
  );
};

export default NotFound;
